import React from 'react';
import { formatPayrollAdjustmentEuro } from '../../../utils/payrollAdjustmentCategories';

type PayrollAdjustmentSummaryCardsProps = {
  bezug: number;
  abzug: number;
  net: number;
  count: number;
  totalLabels?: boolean;
};

export function PayrollAdjustmentSummaryCards({
  bezug,
  abzug,
  net,
  count,
  totalLabels = false,
}: PayrollAdjustmentSummaryCardsProps) {
  const suffix = totalLabels ? ' (gesamt)' : '';
  const cards = [
    { label: `Bezüge${suffix}`, value: `+ ${formatPayrollAdjustmentEuro(bezug)}`, className: 'text-emerald-600' },
    { label: `Abzüge${suffix}`, value: `− ${formatPayrollAdjustmentEuro(abzug)}`, className: 'text-red-600' },
    {
      label: 'Netto-Effekt',
      value: `${net >= 0 ? '+ ' : '− '}${formatPayrollAdjustmentEuro(Math.abs(net))}`,
      className: 'text-app-text',
    },
    { label: 'Buchungen', value: String(count), className: 'text-app-text' },
  ];

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.label}
          className="rounded-lg border border-app-border bg-app-surface px-4 py-3.5"
        >
          <p className="text-xs font-medium text-app-text-muted">{card.label}</p>
          <p className={`mt-1 text-xl font-semibold ${card.className}`}>{card.value}</p>
        </div>
      ))}
    </div>
  );
}
